import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'react-router-redux'
import axios from 'axios'

// Styles
import styles from './styles'

// Material UI
import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import Stepper, { Step, StepLabel, StepContent } from 'material-ui/Stepper'
import Button from 'material-ui/Button'
import Paper from 'material-ui/Paper'
import Input, { InputLabel } from 'material-ui/Input'
import { MenuItem } from 'material-ui/Menu'
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from 'material-ui/Table'
import Select from 'material-ui/Select'
import Radio, { RadioGroup } from 'material-ui/Radio'
import TextField from 'material-ui/TextField'
import {
  FormLabel,
  FormControl,
  FormControlLabel,
  FormHelperText
} from 'material-ui/Form'
import * as algoliasearch from 'algoliasearch'

let id = 0
function createData(rating, userbase) {
  id += 1
  return { id, rating, userbase }
}

const data = [
  createData(7.0, 3008),
  createData(8.0, 1322),
  createData(8.5, 706),
  createData(9.0, 471),
  createData(9.5, 170),
  createData(10.0, 53)
]

var client = algoliasearch('5B2G72ZK2N', '1aaebeea6fc4b1dd6695ee42d9d823c1')

class Start extends Component {
  constructor(props) {
    super(props)

    this.state = {
      height: 'Average',
      body: 'Slim',
      race: 'White',
      showPopulation: false,
      popCount: 'Loading...',
      popLoaded: false,
      nbHits: ' ~',
      all_values: '',
      name: '',
      loadSavedSearch: false
    }
  }

  onNext() {
    this.props.changeRoute(
      `/console/search/saved_searches/filter/text_filter/results?query=${
        this.state.name
      }&saved_search_id=${this.state.search_id}`
    )
  }

  /*
  {
  "Oar_Low":7,
  "Oar_High":10,
  "Profile_Oldest_Dating_Age":0,
  "Include_NA":0,
  "Education_Low":-1,
  "Income_Low":0}
  */
  handleChange = name => event => {
    this.setState({
      name: event.target.value
    })

    if (event.target.value.length > 3) {
      var index = client.initIndex('Candidates')
      let myComponent = this

      const filters = `(ProfAge:${
        this.state.saved_search_data.Youngest_Dating_Age
      } TO ${this.state.saved_search_data.Oldest_Dating_Age}) AND (Dsc_ID: ${
        this.state.saved_search_data.DSC_Low
      } TO ${this.state.saved_search_data.DSC_High}) AND (color_id:${
        this.state.saved_search_data.Color_Low
      } TO ${this.state.saved_search_data.Color_High})`

      index.search(
        {
          query: `${event.target.value}`,
          filters: filters
        },
        function searchDone(err, content) {
          if (err) throw err
          console.log(content)
          myComponent.setState({
            nbHits: content.nbHits,
            showPopulation: true
          })
        }
      )
    } else {
      this.setState({
        showPopulation: false,
        nbHits: ' ~'
      })
    }
  }

  onShowPopulation = () => {}

  async getSavedSearch() {
    let urlParams = new URLSearchParams(window.location.href)
    let saved_search_id = urlParams.get('search_id').replace('%20', '')

    let myComponent = this
    let url =
      'https://dsn-dev.appspot.com/v1/proxy?url=https://api.dsnapis.com/customer/' +
      this.props.customer_number +
      '/pw/teSt1/fltr/' +
      saved_search_id +
      '/db/2'
    await axios.get(url).then(function(response) {
      if (response.data) {
        //alert(JSON.stringify(response.data))
        myComponent.setState({
          saved_search_data: response.data[0],
          loadSavedSearch: true
        })
      }
    })
  }

  componentDidMount() {
    setTimeout(this.getSavedSearch(), 2000)
  }

  render() {
    const { classes, theme, location } = this.props
    const { showPopulation, loadSavedSearch } = this.state

    if (loadSavedSearch) {
      return (
        <div className={classes.root}>
          <br />
          <Typography type="body2" color="inherit" className={classes.flex}>
            Full Text Search
          </Typography>
          <br />
          <TextField
            id="name"
            label="Search any candidate attribute"
            className={classes.textField}
            margin="normal"
            value={this.state.name}
            onChange={this.handleChange('name')}
          />
          <br />
          <br />
          <Typography type="body2" color="inherit" className={classes.flex}>
            Population Count is {this.state.nbHits}
          </Typography>
          <div className={classes.buttonNext}>
            {!this.state.showPopulation && (
              <Button
                disabled
                raised
                onClick={() => this.onNext()}
                color="primary"
                align="center"
                className={classes.button}
              >
                Search Candidates
              </Button>
            )}
            {this.state.showPopulation && (
              <Button
                raised
                onClick={() => this.onNext()}
                color="primary"
                align="center"
                className={classes.button}
              >
                Search Candidates
              </Button>
            )}
          </div>
        </div>
      )
    } else {
      return <div className={classes.root}>Loading...</div>
    }
  }
}

function mapStateToProps(state) {
  return {
    customer_number: state.customer.number,
    project_id: state.prefix.project_id,
    oarlow: state.oar.low,
    oarhigh: state.oar.high,
    step: state.step.step
  }
}

function matchDispatchToProps(dispatch) {
  return {
    dispatch,
    changeRoute: url => dispatch(push(url))
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(mapStateToProps, matchDispatchToProps)(Start)
  )
)



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/SavedSearches/scenes/Filters/scenes/TextFilter/scenes/Start/index.js